import perspectives from './camera-perspectives.json';

const values = Object.values(perspectives);

export const getCameraPerspectiveByIndex = (index: number) => values[index];
